(function($) {
    var _generateID = function() {
        return 'modalTrigger_' + generateUUID();
    };

    $.fn.extend({
        openModal: function(options) {

            var defaults = {
                ready: undefined,
                complete: undefined,
                closeOnEsc: true,
                closeOnClickOff: false,
                disabledHandle: null
            },
            $modal = $(this),
            $overlay = $modal.find(".modal-close--background");

            // Override defaults
            options = $.extend(defaults, options);

            if($overlay.length == 0) {
                $overlay = $('<div class="modal-close--background"></div>');
                $modal.prepend($overlay);
            }

            if ($modal.hasClass('is-open')) {
                return;
            }

            $modal.addClass('is-open').attr("aria-hidden","false");

            //Trap Focus and Release
            // Can cause weird edge cases and break alertify prompts. Test your modals!
            if(typeof ally !== "undefined"){

                focusTrapEngage({
                    context: $modal[0]
                })
                $modal.on("modal:close", function(){
                    focusTrapDisengage();
                });
            }


            if (options.closeOnEsc) {
                // Return on ESC
                $(document).on('keyup',$modal, function(e) {
                    if (e.keyCode === 27) {   // ESC key
                        $modal.closeModal(options);
                    }
                });
            }

            if (options.closeOnClickOff) {
                $overlay.addClass("is-clickable");
                $overlay.click(function() {
                    $modal.closeModal(options);
                    //console.log("click overlay")
                });
            }

            $modal.find(".modal-close").on('click.close', function(e) {
                $modal.closeModal(options);
            });
            $modal.trigger("modal:open");

            //$modal.data('associated-overlay', $overlay[0]);

        }
    });

    $.fn.extend({
        closeModal: function(options) {
            var defaults = {
                complete: undefined
            };
            var $modal = $(this);
            $modal.removeClass('is-open').attr("aria-hidden","true");

            options = $.extend(defaults, options);

            $modal.find('.modal-close').off('click.close');
            $(document).off('keyup',$modal);
            $modal.trigger("modal:close");

        }
    });

    $.fn.extend({
        modal: function(option) {
            return this.each(function() {

                var defaults = {
                };
                // Override defaults

                var options = $.extend(defaults, option);
                if($(this).data('escape') != undefined){
                    defaults.closeOnEsc = $(this).data('escape');
                }
                // check if this has an id for aria referencing
                if( $(this).attr("id") == undefined || $(this).attr("id").length == 0 ) {
                    $(this).attr("id",_generateID());
                }
                // Close Handlers
                $(this).click(function(e) {
                    var sModalSelector = $(this).attr("href") || '#' + $(this).data('target');
                    $(sModalSelector).attr({
                        "aria-labelledby": $(this).attr("id"),
                        "role": "dialog",
                        "tabindex" : "-1"
                    }).openModal(options);
                    e.preventDefault();
                }); // done set on click
            }); // done return
        }
    });

    $(document).ready(function(){
        $('.modal-trigger').modal();
    });

})(jQuery);

function buildModal(sHTML,options){
    var defaults = {
        includeHeader: true,
        includeFooter: false,
        header: '',
        labelledby: '',
        classes: 'modal',
        id: "modal_" + generateUUID()
    }
    var settings = $.extend({}, defaults, options );

    var hbstemplate = mantlhbs.modal;
    var output = hbstemplate(settings);
    var $modal = $(output);
    $modal.find(".modal-body").append(sHTML);
    return $modal;
};

function buildModaliFrame(sURL,options){
    var defaults = {
        includeHeader: true,
        includeFooter: false,
        header: '',
        labelledby: '',
        classes: 'modal',
        id: "modal_" + generateUUID()
    }
    var settings = $.extend({}, defaults, options );

    var hbstemplate = mantlhbs.modal;
    var output = hbstemplate(settings);
    var $modal = $(output);
    $iframe = $("<iframe />");
    $iframe.attr("src", sURL).attr("tabindex", '0').width("100%").height("100%");
    $modal.find(".modal-body").append($iframe);
    return $modal;
};
